import React from "react";
import { string } from "yup";
import Input from "./Base";
import InputMaskWithRef from "./InputMaskWithRef";
const dateOfBirthRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const dateOfBirthMask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
export const schema = string().required("A date of birth is required.").matches(dateOfBirthRegex, "Please enter a valid date of birth.");
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Date of Birth",
  InputComponent: InputMaskWithRef,
  required: true,
  mask: dateOfBirthMask,
  inputMode: "numeric",
  ...props
}));
